import { createContext, Dispatch, SetStateAction } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { IApplicationFormValues } from 'interfaces/application'
import { IProperty } from 'interfaces/property'

interface IApplicationContext {
  isOtpVerified?: boolean
  setIsOtpVerified?: Dispatch<SetStateAction<boolean>>
  isEntireHouse?: boolean
  isLoading?: boolean
  setIsLoading?: Dispatch<SetStateAction<boolean>>
  isBackLoading?: boolean
  setIsBackLoading?: Dispatch<SetStateAction<boolean>>
  paymentClientSecret: string | null
  nextStep: () => void
  setStep: (step: number) => void
  handleNextStep?: () => Promise<void>
  handlePreviousStep?: () => Promise<void>
  setValue?: UseFormSetValue<IApplicationFormValues>
  isPaymentSuccessful?: boolean
  setIsPaymentSuccessful?: Dispatch<SetStateAction<boolean>>
  isDriverLicenseVerified?: boolean
  setIsDriverLicenseVerified?: Dispatch<SetStateAction<boolean>>
  completeScreeningStep?: number
  setCompleteScreeningStep?: Dispatch<SetStateAction<number>>
  checkedItems?: string[]
  setCheckedItems?: Dispatch<SetStateAction<string[]>>
  isFetchContinueApplyingData?: boolean
  houseDetail?: IProperty
  chosenUnitId?: number
  setChosenUnitId?: Dispatch<SetStateAction<number>>
  isContinueApplying?: boolean
}

export const ApplicationContext = createContext<IApplicationContext>({} as IApplicationContext)
